import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { Autorizacao } from '@/types/core'
import ComplexidadeEnum from '@/types/enum/ComplexidadeEnum'
import TipoTabelaProcedimentoEnum from '@/types/enum/TipoTabelaProcedimentoEnum'
// eslint-disable-next-line
import {
  AgendamentoSolicitacaoItem,
  AgendamentoFiltro,
  AgendamentoCirurgia,
  Lembrete,
  StatusAvaliacaoPreAnestesia,
  NovaDataSolicitada,
  Convenio,
  Situacao,
  StatusCirurgiaEnum,
  Hospital,
  CentroCirurgico,
  // eslint-disable-next-line
} from '@/types/_'
import { getUser } from '@/utils/common'
import { permissionService } from '@/services/permission.service'
import { useConvenios, useHospitais } from '@/composables'


@Module({ namespaced: true, name: 'BackofficeAutorizacaoStore' })
export default class BackofficeAutorizacaoStore extends VuexModule {
  private autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  private novaDataSolicitadaDefault: NovaDataSolicitada = {
    dataAgendamento: null,
    dataAgendamentoVirtual: false,
    solicitacaoId: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opcao: 0,
    data: '',
    hora: '',
    alterarData: false,
    numeroAgendamento: '',
  }

  private lembreteDefault: Lembrete = {
    dataLembrete: null,
  }

  public lembrete: Lembrete = { ...this.lembreteDefault }

  public lembreteStatusFiltro: string = ''
  public deFiltro: Date | string | null = null
  public ateFiltro: Date | string | null = null
  public medicoId: string = ''
  public paciente: string = ''
  public medicosCadastrados: any = []
  public hospitaisFiltro: string[] = []
  public convenioFiltro: string[] = []
  public preAnestesiaFiltro: string = ''
  public opmeFiltro: string = ''
  public altaPrioridadeFiltro: boolean | null = null
  public autorizacaoParcialAceitaPeloMedicoFiltro: boolean | null = null
  public primeiroTratamentoFiltro: boolean | null = null
  public novaDataSolicitadaFiltro: boolean = false
  public dataPrevistaFiltro: boolean = false
  public dataVirtualFiltro: boolean = false
  public origemFiltro: string | null = null
  public caraterFiltro: string | null = null
  public possuiItemParticular: boolean | null = null
  public statusPrecificacaoOperadoraFiltro: string | null = null
  public cirurgiaRealizada: StatusCirurgiaEnum | null = null
  public complexidade: ComplexidadeEnum[] = []
  public numeroAgendamento: string = ''
  public ordenadoPorId: string = 'DataUltimaInteracaoAsc'
  public etapaQuery: string = ''
  public statusAvaliacaoPreAnestesiaQuery: string[] = []
  public data: string[] = []
  public situacoes: string[] = ['analisePreAutorizacao', 'analisePreCotacao']
  public situacoesPendenciaAbertaFiltro: string[] = []
  public situacoesPendenciaAberta: Situacao[] = []
  public situacoesCounter: Situacao[] = []
  public ordenadoPor: any = [
    { id: 'DataUltimaInteracaoAsc', value: 'Tempo de ação mais antigo' },
    { id: 'DataUltimaInteracaoDesc', value: 'Tempo de ação mais recente' },
    { id: 'DataDoEnvioAsc', value: 'Data de envio mais antigo' },
    { id: 'DataDoEnvioDesc', value: 'Data de envio mais recente' },
    { id: 'AutorizacaoValidadeAsc', value: 'Data de validade mais antiga' },
    { id: 'AutorizacaoValidadeDesc', value: 'Data de validade mais recente' },
    { id: 'ProximasCirurgias', value: 'Próximas cirurgias' },
  ]

  public todosOsStatus: boolean = false
  public todosOsStatusDaArea: boolean = false

  public statusAvaliacaoPreAnestesia: StatusAvaliacaoPreAnestesia[] = []
  public preAnestesiaStatus: any[] = [
    { nome: 'Pendente', status: 'Pendente' },
    { nome: 'Apto', status: 'Apto' },
    { nome: 'Apto com atenção', status: 'AptoComAtencao' },
    { nome: 'Não apto', status: 'NaoApto' },
  ]

  public visualizarTriagem: boolean = false
  public novaDataSolicitada: NovaDataSolicitada = { ...this.novaDataSolicitadaDefault }
  public agendamentosCirurgia: AgendamentoCirurgia[] = []

  public filterOn: boolean = false
  public filterDrawer: boolean = false
  public solicitacoes: AgendamentoSolicitacaoItem[] = []

  private paginaDefault: number = 1
  private qtdPorPaginaDefault: number = 25

  public pagina: number = this.paginaDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  public totalSolicitacoes: number = 0
  public reservaUti: string[] = []
  public statusRoboAutorizacao: string[] = []
  public mapaCirurgicoStatus: string[] = []
  public tiposAcomodacao: string[] = []
  public sexo: string = ''
  public medicoSolicitanteEspecialidade: string[] = []
  public centrosCirurgico: CentroCirurgico[] = []
  public centroCirurgico: string = ''
  public tipoPeriodo: string = 'DataAgendamento'
  public procedimentoPrincipalTipoTabela: TipoTabelaProcedimentoEnum[] = []
  public procedimentoPrincipalIds: string[] = []

  segueOProtocoloFilter: string[] = []
  fidelizationStatus: string[] = []
  protocoloOperadora: string = ''
  categoriaDoPlanoParaFidelizacao: string[] = []
  agrupadorHospital: string[] = []
  protocolosEspecialidade: string[] = []

  get hospitais() {
    return useHospitais.hospitaisByCurrentUser
  }

  get convenios() {
    return useConvenios.conveniosByCurrentUser
  }

  @Mutation
  setTodosOsStatus(value: boolean) {
    if (value && !this.todosOsStatusDaArea) this.situacoes = []
    if (value && this.todosOsStatusDaArea) { this.todosOsStatusDaArea = false; this.situacoes = [] }
    if (!value) this.situacoes = ['analisePreAutorizacao', 'analisePreCotacao']
    this.todosOsStatus = value
  }

  @Mutation
  setTodosOsStatusDaArea(value: boolean) {
    if (value && !this.todosOsStatus) this.situacoes = []
    if (value && this.todosOsStatus) { this.todosOsStatus = false; this.situacoes = [] }
    if (!value) this.situacoes = ['analisePreAutorizacao', 'analisePreCotacao']
    this.todosOsStatusDaArea = value
  }

  @Mutation
  setTipoPeriodo(value: string) {
    this.tipoPeriodo = value
  }

  @Mutation
  setCentroCirurgico(value: any) {
    this.centroCirurgico = value
  }

  @Mutation
  setCentrosCirurgico(value: CentroCirurgico[]) {
    this.centrosCirurgico = value
  }

  @Mutation
  clearCentroCirurgico() {
    this.centroCirurgico = ''
  }

  @Mutation
  setReservaUti(value: string[]) {
    this.reservaUti = value
  }

  @Mutation
  setStatusRoboAutorizacao(value: string[]) {
    this.statusRoboAutorizacao = value
  }

  @Mutation
  setmapaCirurgicoStatus(value: string[]) {
    this.mapaCirurgicoStatus = value
  }

  @Mutation
  setTiposAcomodacao(value: string[]) {
    this.tiposAcomodacao = value
  }

  @Mutation
  setSexo(value: string) {
    this.sexo = value
  }

  @Mutation
  setMedicoSolicitanteEspecialidade(value: string[]) {
    this.medicoSolicitanteEspecialidade = value
  }

  @Mutation
  setFilterDrawer(value: boolean) {
    this.filterDrawer = value
  }

  @Mutation
  setAgendamentos(solicitacoes: AgendamentoSolicitacaoItem[]) {
    const slct = solicitacoes.map((e: any) => {
      if (!e.lembreteStatus) e.lembreteStatus = ''
      if (e.statusCirurgia) {
        e.cirurgiaRealizada = e.statusCirurgia === StatusCirurgiaEnum.Realizada
      }
      return e
    })
    this.solicitacoes = slct
  }

  @Mutation
  setAgendamentoCirurgia(solicitacaoAlterada: any) {
    const index = this.solicitacoes.findIndex((e: any) => e.id === solicitacaoAlterada.solicitacaoId)
    if (![-1, undefined].includes(index)) {
      this.solicitacoes[index].convenioId = solicitacaoAlterada.convenioId
      this.solicitacoes[index].convenioNome = solicitacaoAlterada.convenioNome
      this.solicitacoes[index].hospitalId = solicitacaoAlterada.hospitalId
      this.solicitacoes[index].hospitalNome = solicitacaoAlterada.hospitalNome
      this.solicitacoes[index].carater = solicitacaoAlterada.carater
      this.solicitacoes[index].procedimentoPrincipalNome = solicitacaoAlterada.procedimentoPrincipalNome
    }
  }

  @Mutation
  setCirurgiaRealizada(value: StatusCirurgiaEnum | null) {
    this.cirurgiaRealizada = value
  }

  @Mutation
  setComplexidade(value: ComplexidadeEnum[]) {
    this.complexidade = value
  }

  @Mutation
  setOrderBy(orderBy: string) {
    this.ordenadoPorId = orderBy
  }

  @Mutation
  setPaciente(paciente: string) {
    this.paciente = paciente
  }

  @Mutation
  setNovaDataSolicitadaFiltro(value: boolean) {
    this.novaDataSolicitadaFiltro = value
  }

  @Mutation
  setDataPrevistaFiltro(value: boolean) {
    this.dataPrevistaFiltro = value
  }

  @Mutation
  setConvenioFiltro(value: string[]) {
    this.convenioFiltro = value
  }

  @Mutation
  setPreAnestesiaFiltro(value: string) {
    this.preAnestesiaFiltro = value
  }

  @Mutation
  setStatusPrecificacaoOperadora(value: string | null) {
    this.statusPrecificacaoOperadoraFiltro = value
  }

  @Mutation
  setOpmeFiltro(value: string) {
    this.opmeFiltro = value
  }

  @Mutation
  setAltaPrioridadeFiltro(value: boolean | null) {
    this.altaPrioridadeFiltro = value
  }

  @Mutation
  setAutorizacaoParcialAceitaPeloMedicoFiltro(value: boolean | null) {
    this.autorizacaoParcialAceitaPeloMedicoFiltro = value
  }

  @Mutation
  setPrimeiroTratamentoFiltro(value: boolean | null) {
    this.primeiroTratamentoFiltro = value
  }

  @Mutation
  setDataVirtualFiltro(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setOrigemFiltro(value: string | null) {
    this.origemFiltro = value
  }

  @Mutation
  setCaraterFiltro(value: string | null) {
    this.caraterFiltro = value
  }

  @Mutation
  setStatusCirurgia(value: StatusCirurgiaEnum | null) {
    this.cirurgiaRealizada = value
  }

  @Mutation
  setDataAgendamentoVirtual(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setSalaVirtual(value: boolean) {
    this.novaDataSolicitada.dataAgendamentoVirtual = value
  }

  @Mutation
  setDataAgendamento(value: string) {
    this.novaDataSolicitada.dataAgendamento = value
  }

  @Mutation
  setPossuiItemParticular(value: boolean | null) {
    this.possuiItemParticular = value
  }

  @Mutation
  setMedicoAssistentes(medicos: any[]) {
    this.medicosCadastrados = medicos
  }

  @Mutation
  setMedicoId(value: string) {
    this.medicoId = value
  }

  @Mutation
  setNumeroAgendamento(value: string) {
    this.numeroAgendamento = value
  }

  @Mutation
  setNumeroReserva(value: string) {
    this.novaDataSolicitada.numeroAgendamento = value
  }

  @Mutation
  setOrdenadoPorId(value: string) {
    this.ordenadoPorId = value
  }

  @Mutation
  setStatusAvaliacaoPreAnestesia(value: StatusAvaliacaoPreAnestesia[]) {
    this.statusAvaliacaoPreAnestesia = value
  }

  @Mutation
  removeSituacoesPendenciaAbertaFiltro(value: string) {
    const index = this.situacoesPendenciaAbertaFiltro.indexOf(value)
    if (index >= 0) this.situacoesPendenciaAbertaFiltro.splice(index, 1)
  }

  @Mutation
  removeConvenioFiltro(value: string) {
    const index = this.convenioFiltro.indexOf(value)
    if (index >= 0) this.convenioFiltro.splice(index, 1)
  }

  @Mutation
  removeReservaUti(value: string) {
    const index = this.reservaUti.indexOf(value)
    if (index >= 0) this.reservaUti.splice(index, 1)
  }

  @Mutation
  removeStatusRoboAutorizacao(value: string) {
    const index = this.statusRoboAutorizacao.indexOf(value)
    if (index >= 0) this.statusRoboAutorizacao.splice(index, 1)
  }

  @Mutation
  removeMapaCirurgicoStatus(value: any) {
    const index = this.mapaCirurgicoStatus.indexOf(value)
    if (index >= 0) this.mapaCirurgicoStatus.splice(index, 1)
  }

  @Mutation
  removeComplexidadeStatus(value: any) {
    const index = this.complexidade.indexOf(value)
    if (index >= 0) this.complexidade.splice(index, 1)
  }

  @Mutation
  removeTipoAcomodacao(value: string) {
    const index = this.tiposAcomodacao.indexOf(value)
    if (index >= 0) this.tiposAcomodacao.splice(index, 1)
  }

  @Mutation
  setData(value: string) {
    if (this.data.includes(value)) return
    this.data.push(value)
  }

  @Mutation
  setStatusAvaliacaoPreAnestesiaQuery(value: string) {
    this.statusAvaliacaoPreAnestesiaQuery.push(value)
  }

  @Mutation
  removeStatusAvaliacaoPreAnestesiaQuery(value: string) {
    const removeArray: any[] = []

    for (let i = 0; i < this.statusAvaliacaoPreAnestesiaQuery.length; i++) {
      if (this.statusAvaliacaoPreAnestesiaQuery[i] === value) removeArray.push(i)
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.statusAvaliacaoPreAnestesiaQuery.splice(removeArray[i], 1)
    }
  }

  @Mutation
  setSegueOProtocoloFilter(value: string[]) {
    this.segueOProtocoloFilter = value
  }

  @Mutation
  setFidelizationStatusFilter(value: string[]) {
    this.fidelizationStatus = value
  }

  @Mutation
  setCategoriaDoPlanoParaFidelizacao(value: string[]) {
    this.categoriaDoPlanoParaFidelizacao.splice(0, this.categoriaDoPlanoParaFidelizacao.length)
    if (value) {
      value.forEach(elem => this.categoriaDoPlanoParaFidelizacao.push(elem))
    }
  }

  @Mutation
  setAgrupadorHospitaisIds(value: string[]) {
    this.agrupadorHospital.splice(0, this.agrupadorHospital.length)
    if (value) {
      value.forEach(elem => this.agrupadorHospital.push(elem))
    }
  }

  @Mutation
  setProtocolosEspecialidadeIds(value: string[]) {
    this.protocolosEspecialidade.splice(0, this.protocolosEspecialidade.length)
    if (value) {
      value.forEach(elem => this.protocolosEspecialidade.push(elem))
    }
  }

  @Mutation
  setProtocoloOperadoraFilter(value: string) {
    this.protocoloOperadora = value
  }

  @Mutation
  setSituacoes(value: string) {
    if (this.situacoes.includes(value)) {
      this.situacoes.splice(this.situacoes.indexOf(value), 1)
    } else {
      this.situacoes.push(value)
    }
  }

  @Mutation
  setSituacoesPendenciaAbertaFiltro(value: string[]) {
    this.situacoesPendenciaAbertaFiltro = value
  }

  @Mutation
  setSituacoesPendenciaAberta(value: Situacao[]) {
    this.situacoesPendenciaAberta = value
  }

  @Mutation
  setAllSituacoes(value: string[]) {
    this.situacoes = value
  }

  @Mutation
  resetSituacoes() {
    this.situacoes = ['analisePreAutorizacao', 'analisePreCotacao']
  }

  @Mutation
  fillAllSituacoes() {
    this.situacoes = [
      'analisePreAutorizacao',
      'analisePreCotacao',
      'incompleta',
      'aguardandoSuprimentos',
      'PendenteDeEnvioRoboDeAutorizacao',
      'emCotacao',
      'pendente',
      'pendenciaRespondida',
      'respostaDoRoboDeAutorizacao',
      'retornoDaAutorizacaoDoHis',
      'analisePosCotacao',
      'aguardandoOperadora',
      'aguardandoNegociacaoParticular',
      'pendenteDeEnvioRoboDeAutorizacao',
      'autorizadaParcial',
      // 'autorizadaAceitaMedico',
      'autorizada',
      'autorizacaoPos',
      'contestacaoMedica',
      'contestacaoPendente',
      'revisaoCirurgicaAutorizacao',
    ]
  }

  @Mutation
  clearSituacoes() {
    this.situacoes = []
  }

  @Mutation
  setSituacoesCounter(value: Situacao[]) {
    this.situacoesCounter = value
  }

  @Mutation
  removeData(value: string) {
    const index = this.data.indexOf(value)
    if (index >= 0) this.data.splice(index, 1)
  }

  @Mutation
  setHospitaisFiltro(value: string[]) {
    this.hospitaisFiltro = value
  }

  @Mutation
  clearHospitaisFiltro() {
    this.hospitaisFiltro = []
  }

  @Mutation
  removeHospitaisFiltro(value: string) {
    const index = this.hospitaisFiltro.indexOf(value)
    if (index >= 0) this.hospitaisFiltro.splice(index, 1)
  }

  @Mutation
  clearConvenioFiltro() {
    this.convenioFiltro = []
  }

  @Mutation
  clearPreAnestesiaFiltro() {
    this.preAnestesiaFiltro = ''
  }

  @Mutation
  clearAgendamentosCirurgia() {
    this.agendamentosCirurgia = []
  }

  @Mutation
  setFilterOn(value: boolean) {
    this.filterOn = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  setTotalSolicitacoes(value: number) {
    this.totalSolicitacoes = value
  }

  @Mutation
  clearFiltro() {
    this.ordenadoPorId = 'DataUltimaInteracaoAsc'
    this.paciente = ''
    this.medicoId = ''
    this.numeroAgendamento = ''
    this.novaDataSolicitadaFiltro = false
    this.dataPrevistaFiltro = false
    this.novaDataSolicitada = { ...this.novaDataSolicitadaDefault }
    this.dataVirtualFiltro = false
    this.possuiItemParticular = null
    this.origemFiltro = null
    this.caraterFiltro = null
    this.statusPrecificacaoOperadoraFiltro = null
    this.convenioFiltro = []
    this.hospitaisFiltro = []
    this.preAnestesiaFiltro = ''
    this.opmeFiltro = ''
    this.altaPrioridadeFiltro = null
    this.autorizacaoParcialAceitaPeloMedicoFiltro = null
    this.primeiroTratamentoFiltro = null
    this.lembreteStatusFiltro = ''
    this.deFiltro = null
    this.ateFiltro = null
    this.statusAvaliacaoPreAnestesiaQuery = []
    this.cirurgiaRealizada = null
    this.medicoSolicitanteEspecialidade = []
    this.data = []
    this.statusRoboAutorizacao = []
    this.centroCirurgico = ''
    this.tipoPeriodo = 'DataAgendamento'
    this.situacoesPendenciaAbertaFiltro = []
    this.complexidade = []
    this.procedimentoPrincipalTipoTabela = []
    this.procedimentoPrincipalIds = []
  }

  @Mutation
  clearPagePagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  @Mutation
  clearSolicitacoes() {
    this.solicitacoes = []
  }

  @Mutation
  deleteSolicitacao(solicitacaoId: string) {
    const index = this.solicitacoes.findIndex(c => c.id === solicitacaoId)
    if (index >= 0) {
      this.solicitacoes.splice(index, 1)
    }
  }

  @Mutation
  setLembreteStatus(params: any) {
    const solicitacao = this.solicitacoes.find((e: any) => e.id === params.solicitacaoId)
    const solicitacaoIndex = this.solicitacoes.findIndex((e: any) => e.id === params.solicitacaoId)
    // @ts-ignore
    solicitacao.lembreteStatus = params.concluido ? '' : 'Normal'
    // @ts-ignore
    this.solicitacoes[solicitacaoIndex] = solicitacao
  }

  @Mutation
  setLembreteStatusFiltro(value: string) {
    this.lembreteStatusFiltro = value
  }

  @Mutation
  setEtapa(etapa: string) {
    this.etapaQuery = etapa
  }

  // @Mutation
  // setRequestArea(area: string) {
  //   this.requestArea = area
  // }

  @Mutation
  setDeFiltro(value: Date | string | null) {
    this.deFiltro = value
  }

  @Mutation
  setAteFiltro(value: Date | string | null) {
    this.ateFiltro = value
  }

  @Mutation
  setProcedimentoPrincipalTipoTabela(value: TipoTabelaProcedimentoEnum[]) {
    this.procedimentoPrincipalTipoTabela = value
  }

  @Mutation
  setProcedimentoPrincipalIds(value: string[]) {
    this.procedimentoPrincipalIds = value
  }


  @Action
  async loadAgendamentosMedicoSearch(solicitacaoId: string = '') {
    const queryString: AgendamentoFiltro = {
      situacao: this.situacoes,
      statusAvaliacaoPreAnestesiaQuery: this.statusAvaliacaoPreAnestesiaQuery,
      data: this.data,
      convenioNome: this.convenioFiltro,
      hospitalId: this.hospitaisFiltro,
      dataAgendamentoVirtual: this.dataVirtualFiltro,
      origemDaSolicitacao: this.origemFiltro,
      carater: this.caraterFiltro,
      statusPrecificacaoOperadora: this.statusPrecificacaoOperadoraFiltro,
      etapa: this.etapaQuery,
      medicoId: this.medicoId,
      numeroAgendamento: this.numeroAgendamento,
      opme: this.opmeFiltro,
      altaPrioridade: this.altaPrioridadeFiltro,
      autorizacaoParcialAceitaPeloMedico: this.autorizacaoParcialAceitaPeloMedicoFiltro,
      primeiroTratamento: this.primeiroTratamentoFiltro,
      orderBy: this.ordenadoPorId,
      paciente: this.paciente,
      pagina: this.pagina,
      preanestesia: this.preAnestesiaFiltro,
      qtdPorPagina: this.qtdPorPagina,
      usuarioId: getUser().profile.sub,
      possuiItemParticular: this.possuiItemParticular,
      medicoSolicitanteEspecialidade: this.medicoSolicitanteEspecialidade,
      lembreteStatus: this.lembreteStatusFiltro,
      statusRoboAutorizacao: this.statusRoboAutorizacao,
      de: this.deFiltro,
      ate: this.ateFiltro,
      statusCirurgia: this.cirurgiaRealizada,
      centroCirurgico: this.centroCirurgico,
      todosOsStatus: this.todosOsStatus,
      solicitacaoId,
      tipoPeriodo: this.tipoPeriodo,
      situacaoPendenciaAberta: this.situacoesPendenciaAbertaFiltro,
      statusProtocolo: this.segueOProtocoloFilter,
      statusFidelizacao: this.fidelizationStatus,
      protocoloOperadora: this.protocoloOperadora,
      categoriaDoPlanoParaFidelizacao: this.canShowFilterByProtocoloProductLine ? this.categoriaDoPlanoParaFidelizacao : undefined,
      agrupadorHospital: this.agrupadorHospital,
      protocolosEspecialidade: this.protocolosEspecialidade,
      complexidade: this.complexidade,
      procedimentoPrincipalTipoTabela: this.procedimentoPrincipalTipoTabela,
      procedimentoPrincipalIds: this.procedimentoPrincipalIds,
    }

    const response = await this.autorizacao.getAllSearch(queryString)

    if (response.success) {
      this.context.commit('setAgendamentos', response.data.solicitacoes)
      this.context.commit('setSituacoesCounter', response.data.situacoes)
      this.context.commit('setTotalSolicitacoes', response.data.totalSolicitacoes)
      this.context.commit('setStatusAvaliacaoPreAnestesia', response.data.statusAvaliacaoPreAnestesia)
      this.context.commit('setSituacoesPendenciaAberta', response.data.situacoesPendenciaAberta)
    }

    return response
  }

  get canShowFilterByProtocoloProductLine() {
    return permissionService.hasPermission('agendamento.backoffice.protocolo.visualizarProductLine')
  }

  @Action
  async getAllConvenios() {
    await useConvenios.loadConveniosByCurrentUser()
  }

  @Action
  async backofficeVoltaStatus(params: any) {
    const request = await this.autorizacao.backofficeVoltaStatus(params)
    if (request.success) {
      await this.context.dispatch('loadAgendamentosMedicoSearch')
    }
    return request
  }

  @Action
  async getAllHospitais() {
    await useHospitais.loadHospitaisByCurrentUser()
  }

  @Action
  async getCentroCirurgicoByHospitalId(params: any) {
    const { hospitalIds } = params
    if (hospitalIds && hospitalIds.length <= 0) {
      this.context.commit('setCentrosCirurgico', [])
      this.context.commit('clearCentroCirurgico')
      return null
    }

    const request = await this.autorizacao.getCentroCirurgico(params)
    if (request.success) {
      request.data.map((c) => {
        const temp = c
        temp.nome = `${c.hospital.nome} - ${c.nome}`
        return temp
      })

      this.context.commit('setCentrosCirurgico', request.data)
    }
    return request
  }

  @Action
  init() {
    this.context.dispatch('getAllHospitais')
    this.context.dispatch('getAllConvenios')
  }
}
